export default __webpack_public_path__ + "static/1-750c22f4c08f4adb2466a9888e27a04c.jpeg";